import { Edit3, Mail } from 'lucide-react'
import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { gmailCreateDraft } from 'sprites-types/workflow/tools/gmailCreateDraft'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'
import { SchemaValidationError } from '../shared/safeParseToolResult'

function GmailCreateDraftDisplayComponent({ nodeExecution }: WorkflowToolComponentProps) {
  const schema = getToolResultSchema(gmailCreateDraft, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const result = parseResult.data
  const inputs = nodeExecution.inputs

  const recipient = inputs.to || 'recipient'
  const subject = inputs.subject || 'No subject'
  const draftId = (result as any)?.draftId || (result as any)?.id

  return (
    <div className="rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
      <div className="flex items-center gap-4 px-4 py-3">
        <div className="flex-shrink-0">
          <div className="rounded-full bg-blue-100 p-2">
            <Edit3 className="h-5 w-5 text-blue-600" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-gray-900">Draft created successfully</div>
          <div className="text-xs text-gray-600">
            To: {recipient} • Subject: {subject}
          </div>
          {draftId && <div className="mt-1 text-xs text-gray-500">Draft ID: {draftId}</div>}
        </div>
        <div className="flex-shrink-0">
          <Mail className="h-5 w-5 text-gray-400" />
        </div>
      </div>
    </div>
  )
}

function downloadGmailCreateDraft(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function gmailCreateDraftToMarkdown(nodeExecution: NodeExecution): string {
  const inputs = nodeExecution.inputs
  const recipient = inputs.to || 'recipient'
  const subject = inputs.subject || 'No subject'

  return `## Draft Created Successfully

**To:** ${recipient}
**Subject:** ${subject}

---
`
}

export const GmailCreateDraftDisplay = createWorkflowToolComponent(
  GmailCreateDraftDisplayComponent,
  downloadGmailCreateDraft,
  gmailCreateDraftToMarkdown
)
